/* ============================================================
   chillbear コレクションLP 専用JS
   #scenes: スクロール連動シーン切り替え（ピン留め）演出
   - GSAP + ScrollTrigger（CDN読込・register は main.js 済み）
   - Lenis は main.js で全域連携済み
     （lenis.on('scroll', ScrollTrigger.update) + raf統合）のため
     ScrollTrigger を使うだけで同期される。lenis 参照は不要。
   - #mainContent の transform / .content-wrap の overflow:hidden 対策として
     pinType:"transform" を使用（position:fixed ピンは祖先 transform で破綻するため）。
   ============================================================ */
(function () {
  "use strict";

  if (!window.gsap || !window.ScrollTrigger) return;

  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;
  if (typeof gsap.registerPlugin === "function") gsap.registerPlugin(ScrollTrigger);

  function init() {
    var section = document.querySelector("#scenes");
    if (!section) return;

    var pin = section.querySelector(".inner");
    var btns = Array.prototype.slice.call(section.querySelectorAll(".scenes_btn"));
    var contents = Array.prototype.slice.call(section.querySelectorAll(".scene-content"));
    var count = contents.length;
    if (!pin || !count) return;

    // フェード時間（秒。小さいほど素早く切り替わる。reduce 設定時は即時）
    var FADE = (window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches) ? 0 : 0.9;

    // .scene-thumbnail 切替時のぼかし量（px）。0 でぼかしなし
    var THUMB_BLUR = 40;

    // 初期状態：先頭シーンのみ表示。
    // シーンの重なりは 0〜2 に固定し、タイトル・ボタン（CSSで z-index 4/5）より
    // 前面に出ないようにする（フェード中に UI が隠れるのを防ぐ）。
    var current = 0;
    contents.forEach(function (c, i) {
      c.style.zIndex = i === 0 ? "2" : "0";
      gsap.set(c, { opacity: i === 0 ? 1 : 0 });
    });

    // ボタンの active 表示と背景切替フックの更新
    function setButtons(index) {
      btns.forEach(function (b, i) { b.classList.toggle("active", i === index); });
      // 背景切替フック：CSS 側で [data-scene="sceneN"] に背景を割り当て可能
      section.setAttribute("data-scene", "scene" + (index + 1));
    }
    setButtons(0);

    // シーン切り替え（時間ベースのフェード。スクロール進捗には連動しない）。
    // 表示中=2 / 直前=1 / その他=0 の3段で重ね、対象を opacity 0→1 でフェードイン。
    // 直前シーンは直下に不透明で残り、先頭シーンも常に不透明の下地として残るため白飛びしない。
    // 常に「上に重ねて新規フェードイン」する方式なので、戻る操作でもフェードが走り、
    // スナップ（一瞬で切り替わる）やキャンセルは起きない。
    function goTo(index) {
      if (index < 0) index = 0;
      if (index > count - 1) index = count - 1;
      if (index === current) return;
      var prev = current;
      current = index;
      contents.forEach(function (c, i) {
        c.style.zIndex = (i === index) ? "2" : (i === prev ? "1" : "0");
      });
      gsap.fromTo(contents[index],
        { opacity: 0 },
        { opacity: 1, duration: FADE, ease: "power2.inOut", overwrite: "auto" }
      );

      // .scene-thumbnail だけ別アニメーション：
      // 旧サムネは上→下に閉じ（ぼかしながら消える）、新サムネは下→上に現れる（ぼかし→クリア）。
      // clip-path inset の top 値を 0%↔100% で動かして縦ワイプを表現する。
      var inThumb = contents[index].querySelector(".scene-thumbnail");
      var outThumb = contents[prev] && contents[prev].querySelector(".scene-thumbnail");
      if (inThumb) {
        gsap.fromTo(inThumb,
          { clipPath: "inset(100% 0% 0% 0%)", filter: "blur(" + THUMB_BLUR + "px)" },
          { clipPath: "inset(0% 0% 0% 0%)", filter: "blur(0px)",
            duration: FADE, ease: "power2.inOut", overwrite: "auto" }
        );
      }
      if (outThumb) {
        gsap.fromTo(outThumb,
          { clipPath: "inset(0% 0% 0% 0%)", filter: "blur(0px)" },
          { clipPath: "inset(100% 0% 0% 0%)", filter: "blur(" + THUMB_BLUR + "px)",
            duration: FADE, ease: "power2.inOut", overwrite: "auto" }
        );
      }

      setButtons(index);
    }

    var st = null;

    // ── Lenis とページ高さの同期（LP内で完結。他ページ用の main.js は変更しない）──
    // ピン留めは pinSpacing で document 高さを動的に増減させるが、その変化が Lenis の
    // スクロール上限(limit)に伝わらず「scenes を抜けた辺りでスクロールが止まる」不整合が起きる。
    // ScrollTrigger の refresh（＝高さ再計算）後に Lenis の上限も再計算させて解消する。
    // ・登録は1回のみ（matchMedia の外）→ リスナー重複を防止
    // ・window.lenis は発火時に存在チェック（読込順に依存しない）
    // ・resize() は上限計算のみで refresh を誘発しない → 無限ループしない
    function syncLenis() {
      if (window.lenis && typeof window.lenis.resize === "function") {
        window.lenis.resize();
      }
    }
    ScrollTrigger.addEventListener("refresh", syncLenis);

    // ピン留め演出はデスクトップ幅のみ（min-width:1001px = CSSのモバイル切替 max-width:1000px と対）。
    // モバイルはアドレスバー伸縮による 100vh/innerHeight の変動＋transformピンの追従遅延で
    // ガタつくため無効化。モバイル/reduce設定時はボタンでのタブ切替のみで動作する。
    var mm = gsap.matchMedia(section);
    mm.add("(min-width: 1001px) and (prefers-reduced-motion: no-preference)", function () {
      st = ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: function () { return "+=" + window.innerHeight * count; },
        pin: pin,
        pinSpacing: true,
        pinType: "transform",      // 祖先の transform / overflow 対策
        anticipatePin: 1,
        invalidateOnRefresh: true,
        // scrub は使わない：一定スクロール量ごとの「しきい値」で離散的に切り替える。
        // フェード自体は goTo() 側の時間ベースアニメーションが担当する。
        onUpdate: function (self) {
          goTo(Math.floor(self.progress * count));
        }
      });
      // 生成直後のスペーサー分を即座に Lenis へ反映（load を待たずに整合させる）
      requestAnimationFrame(syncLenis);
      return function () { st = null; };
    });

    // ボタンクリック：ピン中は該当シーンのしきい値位置へジャンプ（中間シーンを挟まない）、
    // 非ピン時はその場で切替
    btns.forEach(function (btn, i) {
      btn.addEventListener("click", function () {
        if (st) {
          var frac = (i + 0.5) / count;
          window.scrollTo({ top: st.start + (st.end - st.start) * frac });
        }
        goTo(i);
      });
    });

    // 画像読み込み完了後に pin 位置を再計算（ずれ防止）
    window.addEventListener("load", function () { ScrollTrigger.refresh(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();

/* ============================================================
   FAQ アコーディオン（GSAP 非依存・独立動作）
   各項目は初期状態で閉じており、クリックで開閉をトグルする。
   （複数同時に開ける。1つだけ開く排他動作にしたい場合は下記コメント参照）
   ============================================================ */
(function () {
  "use strict";

  function initFaq() {
    var items = document.querySelectorAll(".chillbear-lp .faq_item");
    if (!items.length) return;

    Array.prototype.forEach.call(items, function (item) {
      var q = item.querySelector(".faq_q");
      if (!q) return;
      q.addEventListener("click", function () {
        // 排他動作にする場合はここで他の .faq_item から open を外す：
        // Array.prototype.forEach.call(items, function (o) {
        //   if (o !== item) { o.classList.remove("open");
        //     o.querySelector(".faq_q").setAttribute("aria-expanded", "false"); }
        // });
        var open = item.classList.toggle("open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFaq, { once: true });
  } else {
    initFaq();
  }
})();

/* ============================================================
   グローバルメニュー（.nav_item / PC幅で常時表示）
   - スクロールスパイ：表示中のセクションに対応するリンクへ active を付与
   - ページ内アンカーをスムーススクロール（Lenis を利用）
   ============================================================ */
(function () {
  "use strict";

  // ▼ クリック後に止まる位置：対象セクションの上部から空ける余白（px）。
  //   例）80 にすると「セクション上部の 80px 手前（上）」で止まる。0 でぴったり上端。
  var NAV_SCROLL_OFFSET = 80;

  function initNav() {
    var nav = document.querySelector(".chillbear-lp .nav");
    if (!nav) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll(".nav_item"));
    if (!links.length) return;

    // href(#id) → セクション要素 の対応を作る
    var targets = [];
    links.forEach(function (a) {
      var href = a.getAttribute("href") || "";
      if (href.charAt(0) !== "#") return;
      var sec = document.getElementById(href.slice(1));
      if (sec) targets.push(sec);
    });
    if (!targets.length) return;

    function setActive(id) {
      links.forEach(function (a) {
        a.classList.toggle("active", a.getAttribute("href") === "#" + id);
      });
    }

    // --- スクロールスパイ：ビューポート中央の線を横切っているセクションを active に ---
    // rootMargin で「上下 -50%」= 画面中央の高さ0のラインを判定基準にする。
    // #scenes はピン留め中ずっと画面内に居るため、その間 active が維持される。
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) setActive(e.target.id);
        });
      }, { rootMargin: "-50% 0px -50% 0px", threshold: 0 });
      targets.forEach(function (sec) { io.observe(sec); });
    }

    // --- スムーススクロール（Lenis）---
    // main.js の全体アンカーハンドラ（jQuery animate）と二重発火しないよう、
    // キャプチャ段階で stopPropagation して <a> の bubble ハンドラに到達させない。
    nav.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest(".nav_item") : null;
      if (!a || !nav.contains(a)) return;
      var href = a.getAttribute("href") || "";
      if (href.charAt(0) !== "#") return;
      var sec = document.getElementById(href.slice(1));
      if (!sec) return;

      e.preventDefault();
      e.stopPropagation();

      if (window.lenis && typeof window.lenis.scrollTo === "function") {
        // Lenis の offset は正値で「さらに下」なので、上に余白を空けるには負値を渡す
        window.lenis.scrollTo(sec, { offset: -NAV_SCROLL_OFFSET, duration: 1.1 });
      } else {
        // フォールバック（Lenis 未使用時）も同じ余白で止める
        var top = sec.getBoundingClientRect().top + window.pageYOffset - NAV_SCROLL_OFFSET;
        window.scrollTo({ top: top, behavior: "smooth" });
      }
    }, true); // capture
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNav, { once: true });
  } else {
    initNav();
  }
})();

/* ============================================================
   クーポンコード コピーボタン（.coupon_copy / GSAP 非依存）
   - コピー文字列は data-clipboard-text 属性で保持（直書き）
   - Clipboard API を使用し、非対応/非secure時は execCommand にフォールバック
   - コピー後はトーストで完了を通知（トースト要素は JS が1つだけ生成）
   ============================================================ */
(function () {
  "use strict";

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // フォールバック（http のLAN IP や旧環境など、Clipboard API が使えない場合）
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.top = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand("copy");
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error("execCommand failed"));
      } catch (err) {
        reject(err);
      }
    });
  }

  function initCoupon() {
    var root = document.querySelector(".chillbear-lp");
    if (!root) return;
    var buttons = root.querySelectorAll(".coupon_copy");
    if (!buttons.length) return;

    // 共有トースト（1つだけ生成して使い回す）
    var toast = document.createElement("div");
    toast.className = "coupon_toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    root.appendChild(toast);

    var timer = null;
    function showToast(msg) {
      toast.textContent = msg;
      toast.classList.add("show");
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { toast.classList.remove("show"); }, 2000);
    }

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener("click", function () {
        var code = btn.getAttribute("data-clipboard-text") || (btn.textContent || "").trim();
        if (!code) return;
        copyText(code).then(function () {
          showToast("クーポンコードをコピーしました");
        }).catch(function () {
          showToast("コピーに失敗しました");
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCoupon, { once: true });
  } else {
    initCoupon();
  }
})();

/* ============================================================
   追従CTA：FV（ファーストビュー）表示中は隠す（FVを抜けたら表示）
   - .fv を IntersectionObserver で監視し、.follow_cta に .is-hidden をトグル
   - JS非実行 / IO非対応時は .is-hidden が付かない＝常時表示（安全なフォールバック）
   - 追加のみで完結。撤去時はこのIIFEと CSS の .follow_cta.is-hidden を消せば元通り
   ============================================================ */
(function () {
  "use strict";

  function initFollowCta() {
    var follow = document.querySelector(".chillbear-lp .follow_cta");
    var fv = document.querySelector(".chillbear-lp .fv");
    if (!follow || !fv || !("IntersectionObserver" in window)) return;

    // 初期はFVが見えている想定なので隠しておく（読み込み時のちらつき防止）
    follow.classList.add("is-hidden");

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // FVが少しでも見えている間は隠す／完全に抜けたら表示
        follow.classList.toggle("is-hidden", e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(fv);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFollowCta, { once: true });
  } else {
    initFollowCta();
  }
})();
